import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const StyledBrandContainer = styled.div`
  position: relative;
  border-radius: ${({ theme }): string => theme.radii.xxl};
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  padding: 75px 20px 28px;
  direction: rtl;
`;
export const StyledLogoContainer = styled(StyledDiv)<{ logo?: string }>`
  position: absolute;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  border: ${({ theme }): string => theme.borders[6]};
  border-color: ${({ theme }): string => theme.colors.secondaryText};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ logo }): string => `background-image: url(${logo})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: 80%;
`;

export const StyledBrandName = styled(StyledDiv)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }): string => theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[8]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  margin-bottom: 28px;
`;
